/*
 * AMU tank comparison widget
 * Shopify asset: assets/amu-tank.js
 * Required placeholder in hero.liquid:
 * <div id="amu-tank-widget" data-amu-tank data-initial-state="compare"></div>
 */
(function () {
  'use strict';

  var mountedWidgets = [];
  var widgetCounter = 0;
  var STYLE_ID = 'amu-tank-widget-styles';
  var SELECTOR = '[data-amu-tank], #amu-tank-widget, .amu-tank-widget';

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '.amu-tank-widget{width:100%;max-width:620px;margin:0 auto;font-family:inherit;}',
      '.amu-tank-widget *{box-sizing:border-box;}',
      '.amu-tank-card{position:relative;overflow:hidden;padding:22px 24px 18px;background:#fff;border:1px solid rgba(34,53,42,.14);border-radius:14px;box-shadow:0 12px 34px rgba(34,53,42,.14);}',
      '.amu-tank-card__title{margin:0 0 10px;color:#232323;font-size:15px;font-weight:750;line-height:1.35;text-align:center;}',
      '.amu-tank-card__title-dot{color:#d59a2b;padding:0 3px;}',
      '.amu-tank-stage{position:relative;width:100%;}',
      '.amu-tank-svg{display:block;width:100%;height:auto;overflow:visible;}',
      '.amu-tank-controls{display:flex;align-items:center;justify-content:center;gap:18px;margin-top:2px;}',
      '.amu-tank-control{min-width:74px;height:31px;padding:0 16px;border:0;border-radius:7px;background:#d7971d;color:#fff;font-family:inherit;font-size:12px;font-weight:700;line-height:1;letter-spacing:.02em;cursor:pointer;box-shadow:0 2px 5px rgba(108,75,15,.22);transition:transform .18s ease,box-shadow .18s ease,background .18s ease;}',
      '.amu-tank-control:hover{transform:translateY(-1px);box-shadow:0 5px 10px rgba(108,75,15,.25);}',
      '.amu-tank-control:focus-visible{outline:3px solid rgba(39,108,61,.25);outline-offset:3px;}',
      '.amu-tank-control[aria-pressed="true"]{background:#b9780f;box-shadow:inset 0 0 0 2px rgba(255,255,255,.28),0 3px 8px rgba(108,75,15,.28);}',
      '.amu-tank-control--compare{display:flex;align-items:center;justify-content:center;gap:13px;min-width:64px;padding:0 10px;border-radius:999px;font-size:18px;font-weight:500;line-height:1;}',
      '.amu-tank-control--compare span{display:block;transform:translateY(-1px);}',
      '.amu-sr-only{position:absolute!important;width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important;border:0!important;}',
      '@media(max-width:520px){.amu-tank-card{padding:17px 14px 14px;border-radius:12px}.amu-tank-card__title{font-size:13px}.amu-tank-controls{gap:10px}.amu-tank-control{min-width:66px;height:30px;padding:0 12px;font-size:11px}.amu-tank-control--compare{min-width:58px;font-size:17px}}'
    ].join('');

    document.head.appendChild(style);
  }

  function template(uid) {
    var insideId = uid + '-inside';
    var beforeId = uid + '-before';
    var afterId = uid + '-after';
    var beforeGradientId = uid + '-before-gradient';
    var afterGradientId = uid + '-after-gradient';

    return [
      '<div class="amu-tank-card">',
        '<div class="amu-tank-card__title">Przed / Po AMU <span class="amu-tank-card__title-dot">•</span> Wizualizacja działania w zbiorniku</div>',
        '<div class="amu-tank-stage">',
          '<svg class="amu-tank-svg" viewBox="0 0 420 275" role="img" aria-label="Porównanie gnojowicy przed i po zastosowaniu AMU">',
            '<defs>',
              '<linearGradient id="' + beforeGradientId + '" x1="0" y1="0" x2="0" y2="1">',
                '<stop offset="0%" stop-color="#756943"/>',
                '<stop offset="55%" stop-color="#66533a"/>',
                '<stop offset="100%" stop-color="#493427"/>',
              '</linearGradient>',
              '<linearGradient id="' + afterGradientId + '" x1="0" y1="0" x2="0" y2="1">',
                '<stop offset="0%" stop-color="#8d8057"/>',
                '<stop offset="60%" stop-color="#796545"/>',
                '<stop offset="100%" stop-color="#5d4732"/>',
              '</linearGradient>',
              '<clipPath id="' + insideId + '" clipPathUnits="userSpaceOnUse">',
                '<path d="M52 108C111 74 309 74 368 108L368 239L52 239Z"/>',
              '</clipPath>',
              '<clipPath id="' + beforeId + '" clipPathUnits="userSpaceOnUse">',
                '<rect data-amu-before-clip x="0" y="54" width="210" height="194"/>',
              '</clipPath>',
              '<clipPath id="' + afterId + '" clipPathUnits="userSpaceOnUse">',
                '<rect data-amu-after-clip x="210" y="54" width="210" height="194"/>',
              '</clipPath>',
            '</defs>',

            '<path d="M52 108C111 74 309 74 368 108L368 239L52 239Z" fill="#f5f4ee"/>',

            '<g clip-path="url(#' + insideId + ')">',
              '<g clip-path="url(#' + beforeId + ')">',
                '<rect x="48" y="116" width="324" height="128" fill="url(#' + beforeGradientId + ')"/>',
                '<path d="M47 119C60 112 72 119 84 115C98 111 110 122 124 117C137 112 150 121 164 116C178 111 190 122 204 116C218 111 231 122 245 117C260 112 273 121 287 116C302 111 316 121 332 116C346 112 359 120 373 115L373 137C356 142 342 134 327 139C312 144 299 134 284 140C269 145 256 135 241 141C226 146 212 136 197 142C182 147 169 137 154 143C139 148 125 138 110 144C94 149 81 139 65 145C59 147 53 146 47 144Z" fill="#8a7747" stroke="#392f21" stroke-width="2.1" stroke-linejoin="round"/>',
                '<path d="M48 137C63 132 77 141 92 136C107 131 120 142 136 137C151 132 165 142 180 137C195 132 209 143 224 137C239 132 254 142 269 137C284 132 299 142 314 137C329 132 344 141 372 136L372 151C350 155 335 148 319 153C303 158 289 149 273 154C257 159 243 150 227 155C211 160 197 151 181 156C165 161 151 152 135 157C119 162 105 153 89 158C73 163 61 156 48 159Z" fill="#6e5a35" opacity=".92"/>',
                '<path d="M49 148C73 141 91 151 112 146C134 141 150 153 172 147C194 141 211 153 233 147C255 141 273 153 295 147C317 141 337 153 372 145" fill="none" stroke="#3f3425" stroke-width="2" opacity=".75"/>',

                '<!-- Gruby, nierówny osad na dnie przed zastosowaniem AMU -->',
                '<path d="M47 218C64 211 80 222 98 216C116 210 133 223 151 217C170 211 188 224 207 218C226 212 244 225 263 218C282 212 300 223 319 217C337 212 354 220 373 216L373 244L47 244Z" fill="#302219" opacity=".98"/>',
                '<path d="M47 218C64 211 80 222 98 216C116 210 133 223 151 217C170 211 188 224 207 218C226 212 244 225 263 218C282 212 300 223 319 217C337 212 354 220 373 216" fill="none" stroke="#806644" stroke-width="2.4" stroke-linecap="round" opacity=".82"/>',
                '<g fill="#19110d" opacity=".72">',
                  '<ellipse cx="80" cy="229" rx="9" ry="3"/>',
                  '<ellipse cx="132" cy="235" rx="13" ry="3.8"/>',
                  '<ellipse cx="185" cy="227" rx="8" ry="2.8"/>',
                  '<ellipse cx="239" cy="236" rx="12" ry="3.5"/>',
                  '<ellipse cx="294" cy="228" rx="10" ry="3.1"/>',
                  '<ellipse cx="345" cy="235" rx="12" ry="3.6"/>',
                '</g>',

              '</g>',

              '<g clip-path="url(#' + afterId + ')">',
                '<rect x="48" y="116" width="324" height="128" fill="url(#' + afterGradientId + ')"/>',
                '<path d="M47 119C94 116 133 121 174 118C215 115 255 121 296 118C326 116 350 118 373 116L373 126C331 128 294 125 255 128C216 131 177 125 138 128C99 131 72 126 47 129Z" fill="#aa9868" opacity=".35"/>',

                '<g fill="#eee8d4" stroke="#4d4636" stroke-width="1.1" opacity=".96">',
                  '<circle cx="249" cy="153" r="3.2"/>',
                  '<circle cx="274" cy="191" r="2.7"/>',
                  '<circle cx="333" cy="161" r="2.8"/>',
                  '<circle cx="351" cy="206" r="3.1"/>',
                  '<circle cx="240" cy="214" r="2.6"/>',
                  '<circle cx="307" cy="220" r="2.8"/>',
                  '<circle cx="356" cy="185" r="2.4"/>',
                '</g>',

                '<g fill="none" stroke="#eee8d4" stroke-width="4" stroke-linecap="round" opacity=".95">',
                  '<path d="M257 166c-7-5-11 2-7 7c3 4 0 8-4 9"/>',
                  '<path d="M296 149c6-5 12 0 9 6c-2 4 1 8 5 9"/>',
                  '<path d="M334 184c-7-4-11 3-7 8c3 4 0 8-4 9"/>',
                  '<path d="M284 207c6-5 11 0 9 5c-2 4 1 8 5 9"/>',
                '</g>',

                '<g fill="none" stroke="#4d4636" stroke-width="1.1" stroke-linecap="round" opacity=".9">',
                  '<path d="M257 166c-7-5-11 2-7 7c3 4 0 8-4 9"/>',
                  '<path d="M296 149c6-5 12 0 9 6c-2 4 1 8 5 9"/>',
                  '<path d="M334 184c-7-4-11 3-7 8c3 4 0 8-4 9"/>',
                  '<path d="M284 207c6-5 11 0 9 5c-2 4 1 8 5 9"/>',
                '</g>',

                '<text x="307" y="181" text-anchor="middle" fill="#f5efdd" stroke="#514936" stroke-width=".45" paint-order="stroke" font-size="10.5" font-family="inherit">bakterie tlenowe</text>',

              '</g>',
            '</g>',

            '<path d="M52 108C111 74 309 74 368 108L368 239L52 239Z" fill="none" stroke="#30302f" stroke-width="5.2" stroke-linejoin="round"/>',
            '<path d="M57 109C115 80 305 80 363 109" fill="none" stroke="#9d9d9a" stroke-width="3.1" stroke-linecap="round"/>',
            '<path d="M43 123H52M368 123H378" fill="none" stroke="#777873" stroke-width="5" stroke-linecap="square"/>',
            '<path d="M43 123H52M368 123H378" fill="none" stroke="#2f302e" stroke-width="1.4"/>',
            '<path d="M58 235H362" fill="none" stroke="#1f201e" stroke-width="2" opacity=".65"/>',

            '<line data-amu-divider x1="210" y1="57" x2="210" y2="242" stroke="#d29a32" stroke-width="2.2"/>',
            '<line data-amu-divider-highlight x1="211.5" y1="57" x2="211.5" y2="242" stroke="#f2c665" stroke-width=".8" opacity=".85"/>',
            '<path data-amu-divider-cap d="M204 58H216" fill="none" stroke="#d29a32" stroke-width="2" stroke-linecap="round"/>',
          '</svg>',
        '</div>',

        '<div class="amu-tank-controls" role="group" aria-label="Wybierz widok zbiornika">',
          '<button type="button" class="amu-tank-control" data-amu-state="before" aria-pressed="false">PRZED</button>',
          '<button type="button" class="amu-tank-control amu-tank-control--compare" data-amu-state="compare" aria-label="Pokaż porównanie przed i po" aria-pressed="true"><span aria-hidden="true">‹</span><span aria-hidden="true">›</span></button>',
          '<button type="button" class="amu-tank-control" data-amu-state="after" aria-pressed="false">PO</button>',
        '</div>',
        '<p class="amu-sr-only" data-amu-live aria-live="polite"></p>',
      '</div>'
    ].join('');
  }

  function mountWidget(root) {
    if (!root || root.getAttribute('data-amu-mounted') === 'true') return;

    root.setAttribute('data-amu-mounted', 'true');
    root.classList.add('amu-tank-widget');

    widgetCounter += 1;
    var uid = 'amu-tank-' + widgetCounter;
    root.innerHTML = template(uid);

    var beforeClip = root.querySelector('[data-amu-before-clip]');
    var afterClip = root.querySelector('[data-amu-after-clip]');
    var divider = root.querySelector('[data-amu-divider]');
    var dividerHighlight = root.querySelector('[data-amu-divider-highlight]');
    var dividerCap = root.querySelector('[data-amu-divider-cap]');
    var live = root.querySelector('[data-amu-live]');
    var buttons = root.querySelectorAll('[data-amu-state]');
    var animationFrame = null;
    var currentX = 210;

    var stateData = {
      before: {
        x: 368,
        status: 'Widok przed zastosowaniem AMU: twardy kożuch, gęsta i niejednorodna gnojowica.'
      },
      compare: {
        x: 210,
        status: 'Porównanie przed i po zastosowaniu AMU.'
      },
      after: {
        x: 52,
        status: 'Widok po zastosowaniu AMU: płynna, jednorodna gnojowica i bakterie tlenowe.'
      }
    };

    function drawAt(x) {
      var safeX = Math.max(52, Math.min(368, x));
      currentX = safeX;

      beforeClip.setAttribute('width', String(safeX));
      afterClip.setAttribute('x', String(safeX));
      afterClip.setAttribute('width', String(420 - safeX));

      divider.setAttribute('x1', String(safeX));
      divider.setAttribute('x2', String(safeX));
      dividerHighlight.setAttribute('x1', String(safeX + 1.5));
      dividerHighlight.setAttribute('x2', String(safeX + 1.5));
      dividerCap.setAttribute('d', 'M' + (safeX - 6) + ' 58H' + (safeX + 6));
    }

    function animateTo(targetX) {
      if (animationFrame) cancelAnimationFrame(animationFrame);

      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        drawAt(targetX);
        return;
      }

      var startX = currentX;
      var delta = targetX - startX;
      var startTime = null;
      var duration = 420;

      function step(timestamp) {
        if (startTime === null) startTime = timestamp;
        var progress = Math.min(1, (timestamp - startTime) / duration);
        var eased = 1 - Math.pow(1 - progress, 3);
        drawAt(startX + delta * eased);

        if (progress < 1) {
          animationFrame = requestAnimationFrame(step);
        } else {
          animationFrame = null;
        }
      }

      animationFrame = requestAnimationFrame(step);
    }

    function updateLegacyText(state) {
      var status = document.getElementById('amu-tank-status');
      var caption = document.getElementById('amu-tank-caption');

      if (status) {
        status.textContent = state === 'before'
          ? 'gęsta, niejednorodna, silny zapach'
          : state === 'after'
            ? 'płynna, jednorodna, mniej zapachu'
            : 'porównanie przed i po';
      }

      if (caption) {
        caption.textContent = state === 'before'
          ? 'Twardy kożuch utrudnia mieszanie i uwalnia amoniak.'
          : state === 'after'
            ? 'Bakterie tlenowe AMU rozbijają kożuch, wiążą azot i ujednorodniają gnojowicę.'
            : 'Po lewej stan przed zastosowaniem AMU, po prawej efekt pracy kultur tlenowych.';
      }
    }

    function setState(state, immediate) {
      var normalized = state === 'split' ? 'compare' : state;
      if (!stateData[normalized]) normalized = 'compare';

      root.setAttribute('data-state', normalized);

      Array.prototype.forEach.call(buttons, function (button) {
        button.setAttribute('aria-pressed', button.getAttribute('data-amu-state') === normalized ? 'true' : 'false');
      });

      if (live) live.textContent = stateData[normalized].status;
      updateLegacyText(normalized);

      if (immediate) {
        drawAt(stateData[normalized].x);
      } else {
        animateTo(stateData[normalized].x);
      }
    }

    Array.prototype.forEach.call(buttons, function (button) {
      button.addEventListener('click', function () {
        setState(button.getAttribute('data-amu-state'));
      });
    });

    root.__amuSetState = setState;
    setState(root.getAttribute('data-initial-state') || 'compare', true);
    mountedWidgets.push(root);
  }

  function initTankWidgets(scope) {
    injectStyles();

    var context = scope && scope.querySelectorAll ? scope : document;
    var roots = context.querySelectorAll(SELECTOR);

    Array.prototype.forEach.call(roots, mountWidget);
  }

  window.amuSetTank = function (state) {
    mountedWidgets = mountedWidgets.filter(function (root) {
      return document.documentElement.contains(root);
    });

    mountedWidgets.forEach(function (root) {
      if (typeof root.__amuSetState === 'function') root.__amuSetState(state);
    });
  };

  function handleVariantClick(event) {
    var btn = event.target.closest ? event.target.closest('.amu-variant-btn') : null;
    if (!btn) return;

    var scope = btn.closest('[data-amu-shop]') || btn.closest('.shopify-section') || document;
    var variantButtons = scope.querySelectorAll('.amu-variant-btn');

    Array.prototype.forEach.call(variantButtons, function (button) {
      button.classList.remove('active');
    });

    btn.classList.add('active');

    var priceEl = scope.querySelector('#amu-spot-price') || document.getElementById('amu-spot-price');
    var idInput = scope.querySelector('#amu-variant-id') || document.getElementById('amu-variant-id');

    if (priceEl && btn.getAttribute('data-price')) {
      priceEl.textContent = btn.getAttribute('data-price');
    }

    if (idInput && btn.getAttribute('data-variant-id')) {
      idInput.value = btn.getAttribute('data-variant-id');
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  document.addEventListener('click', handleVariantClick);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initTankWidgets(document);
    });
  } else {
    initTankWidgets(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initTankWidgets(event.target || document);
  });
})();
